import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import dummyProfileImg from "../../../../assets/images/dummy_profile.jpeg";
import "../../CustomerPreview.scss";
import { RESIDENT_STATUS, applicantCountConstant } from "../../../../config/constant";
import { formatDate } from "../../../../utilis/common-funtions";
import { useTranslation } from "react-i18next";
const { REACT_APP_S3_BASE_URL } = process.env;

const ApplicantDetails = ({ applicantData, masterData }) => {
  const { t } = useTranslation();
  const [applicantList, setApplicantList] = useState([]);
  let maritalStatusName = "N/A";

  useEffect(() => {
    let obj = [];
    if (applicantData && applicantData?.applicant1 !== null) {
      obj.push(applicantData?.applicant1);
    }
    if (applicantData && applicantData?.applicant2 !== null) {
      obj.push(applicantData?.applicant2);
    }
    setApplicantList(obj);
  }, [applicantData]);

  const getMaritalStatus = (value) => {
    if (value === null) {
      return maritalStatusName;
    } else {
      maritalStatusName = masterData?.Marital_Status?.find((data) => data?.value === value)?.name;
      return maritalStatusName;
    }
  };

  const getGenderName = (value) => {
    if (value) {
      let genderName = masterData?.GenderIdentity?.find(
        (data) => data?.value === value
      )?.name;
      return genderName;
    }
  };

  const formatAddress = (address) => {
    if (!address) return "N/A";

    const baseAddress = address?.houseNumber + ", " + address?.areaName;
    const pinCodeSuffix = address?.pinCode ? ", " + address?.pinCode : "";

    return address?.areaName?.includes(address?.pinCode)
      ? baseAddress
      : baseAddress +
      ", " +
      address?.city +
      ", " +
      address?.state +
      ", " +
      address?.country + pinCodeSuffix;
  };

  return (
    <>
      {applicantList &&
        applicantList?.length > 0 &&
        applicantList?.map((data, index) => {
          const companyPincodeSuffix = data?.professionalDetails
            ?.companyPinCode
            ? `, ${data.professionalDetails.companyPinCode}`
            : ""

          const officeAddress = data?.professionalDetails?.officeAddress;
          const officePinCode = data?.professionalDetails?.officePinCode;

          let formattedOfficeAddress = "N/A";

          if (officeAddress) {
            formattedOfficeAddress = officeAddress.includes(officePinCode)
              ? officeAddress
              : `${officeAddress}, ${officePinCode || ""}`;
          }

          return (
            <div
              key={index}
              className={`applicantDetailsCard applicant${index + 1}`}
            >
              <div className="editTitleRow">
                <div className="btnApplicantTop">
                  {index + 1 === 1 ? (
                    applicantCountConstant?.numberKeys[1]
                  ) : (
                    <>
                      {index + 1}
                      <sup>
                        {applicantCountConstant?.numberKeys[index + 1]}
                      </sup>
                    </>
                  )}{" "}
                  Applicant
                </div>
              </div>

              <div className="personalInformation">
                <div className="photo">
                  {data?.personalDetails?.image?.length > 0 ? (
                    <img
                      src={`${REACT_APP_S3_BASE_URL +
                        "/" +
                        data?.personalDetails?.image?.[0]
                        }`}
                      alt="User"
                    />
                  ) : (
                    <img src={`${dummyProfileImg}`} alt="User" />
                  )}
                </div>
                <div className="informationDetails">
                  <h2 className="name">{`${data?.personalDetails?.salutation} ${data?.personalDetails?.firstName
                    }${" "}${data?.personalDetails?.lastName}`}</h2>
                  <h3 className="relationOfApplicant">{masterData?.Identity?.find((item) => item.value === data?.personalDetails?.relation)?.name || "Relation with"}: {data?.personalDetails?.relativeName}</h3>
                  <h3 className="titlePersonalHD">Personal Details</h3>
                  <div className="personalInfo width50">
                    <div className="personalInfoRow">
                      <p className="label150">{index + 1 === 1 ? "Primary Registration Phone number:" : "Contact Number:"}</p>
                      <span>
                        {data?.personalDetails?.countryCode === undefined
                          ? "N/A"
                          : `${data?.personalDetails?.countryCode}${data?.personalDetails?.contactNumber}`}
                      </span>
                    </div>
                    {data?.personalDetails?.alternateContactNumber &&
                      <div className="personalInfoRow">
                        <p className="label180">Alternate Contact No.:</p>
                        <span className="marginLeft30">
                          {data?.personalDetails?.alternateCountryCode === undefined
                            ? "N/A"
                            : `${data?.personalDetails?.alternateCountryCode}${data?.personalDetails?.alternateContactNumber}`}
                        </span>
                      </div>
                    }

                    <div className="personalInfoRow">
                      <p className="label150">Email ID:</p>
                      <span
                        style={{
                          display: 'flex',
                          wordBreak: 'break-word', // Break long words
                          whiteSpace: 'normal', // Allow wrapping
                          maxWidth: '100%', // Ensure it respects container width
                        }} className="wordBreakMobile">
                        {data?.personalDetails?.emailAddress || "N/A"}
                      </span>
                    </div>
                    <div className="personalInfoRow">
                      <p className="label150">Date of Birth:</p>
                      <span>{data?.personalDetails?.dob ? formatDate(data?.personalDetails?.dob) : "N/A"}</span>
                    </div>

                    <div className="personalInfoRow">
                      <p className="label150">Residential Status:</p>
                      <span>
                        {data?.personalDetails?.residentStatus || "N/A"}
                      </span>
                    </div>

                    {data?.personalDetails?.nriCountry && (
                      <div className="personalInfoRow">
                        <p className="label150">Country of Residence:</p>
                        <span>
                          {data?.personalDetails?.nriCountry || "N/A"}
                        </span>
                      </div>
                    )}

                    <div className="personalInfoRow">
                      <p className="label150">Marital Status:</p>
                      <span>
                        {getMaritalStatus(
                          data?.personalDetails?.maritalStatus
                        ) || "N/A"}
                      </span>
                    </div>

                    <div className="personalInfoRow">
                      <p className="label150">Gender:</p>
                      <span>{getGenderName(data?.personalDetails?.gender) || "N/A"}</span>
                    </div>
                  </div>
                </div>
              </div>
              <div className="lineDotted"></div>
              <div className="personalInfo width50">
                {data?.contactDetails?.panNumber !== null &&
                  data?.contactDetails?.panNumber?.length > 0 ? (
                  <div className="personalInfoRow">
                    <p className="label180">PAN Number:</p>
                    <span>{data?.contactDetails?.panNumber || "N/A"}</span>
                  </div>
                ) : null}
                {data?.contactDetails?.aadhaarNumber !== null &&
                  data?.contactDetails?.aadhaarNumber?.length > 0 ? (
                  <div className="personalInfoRow">
                    <p className="label180">Aadhaar Number:</p>
                    <span>{data?.contactDetails?.aadhaarNumber || "N/A"}</span>
                  </div>
                ) : null}

                {data?.personalDetails?.residentStatus ===
                  RESIDENT_STATUS?.Indian ? null : (
                  <>
                    {data?.contactDetails?.passportNumber !== null &&
                      data?.contactDetails?.passportNumber?.length > 0 ? (
                      <div className="personalInfoRow">
                        <p className="label180">Passport Number:</p>
                        <span>
                          {data?.contactDetails?.passportNumber || "N/A"}
                        </span>
                      </div>
                    ) : null}
                    {data?.contactDetails?.ociNumber !== null &&
                      data?.contactDetails?.ociNumber?.length > 0 ? (
                      <div className="personalInfoRow">
                        <p className="label180">OCI Number:</p>
                        <span>{data?.contactDetails?.ociNumber || "N/A"}</span>
                      </div>
                    ) : null}
                    {data?.contactDetails?.OCIAlternateDocType !== null &&
                      data?.contactDetails?.OCIAlternateDocType?.length > 0 ? (
                      <div className="personalInfoRow">

                        <p className="label180">OCI Document Type:</p>

                        <span>{data?.contactDetails?.OCIAlternateDocType || "N/A"}</span>
                      </div>
                    ) : null}
                  </>
                )}
              </div>
              <div className="notes">
                Note: All uploaded documents are included in the KYC document
                section
              </div>
              <div className="lineDotted"></div>

              <h3 className="titlePersonalHD marginBottom10">
                Communication Details
              </h3>
              <div className="personalInfo Communication width50">
                {index !== 1 && (
                  <div className="personalInfoRow">
                    <p className="label180">Permanent Address:</p>
                    <span>
                      {formatAddress(data?.contactDetails?.permanentAddress)}
                    </span>
                  </div>
                )}
                <div className="personalInfoRow">
                  <p className="label180">Communication Address:</p>
                  {index === 0 ? (
                    <span>
                      {formatAddress(data?.contactDetails?.communicationAddress)}
                    </span>
                  ) : (
                    <span>
                      {formatAddress(data?.contactDetails?.permanentAddress)}

                    </span>
                  )}
                </div>
              </div>
              <div className="lineDotted"></div>
              <h3 className="titlePersonalHD marginBottom10">
                Professional Details
              </h3>
              <div className="personalInfo width50">
                {data?.professionalDetails?.occupation ? (
                  <div className="personalInfoRow">
                    <p className="label200">Occupation:</p>
                    <span style={{
                      display: 'flex',
                      wordBreak: 'break-word', // Break long words
                      whiteSpace: 'normal', // Allow wrapping
                      maxWidth: '100%', // Ensure it respects container width
                    }}>

                      {data?.professionalDetails?.occupation || "N/A"}
                    </span>
                  </div>
                ) : null}

                {data?.professionalDetails?.industry && (
                  <div className="personalInfoRow">
                    <p className="label200">
                      {t("professionalDetails.fields.industry")}:
                    </p>
                    <span>
                      {data?.professionalDetails?.industry ||
                        "N/A"}
                    </span>
                  </div>
                )}

                {data?.professionalDetails?.companyName && (
                  <div className="personalInfoRow">
                    <p className="label200">
                      {t(
                        "professionalDetails.fields.companyName"
                      )}
                      :
                    </p>
                    <span>
                      {data?.professionalDetails?.companyName ||
                        "N/A"}
                    </span>
                  </div>
                )}

                {data?.professionalDetails?.departmentDivision && (
                  <div className="personalInfoRow">
                    <p className="label200">
                      {t(
                        "professionalDetails.fields.departmentDivision"
                      )}
                      :
                    </p>
                    <span>
                      {data?.professionalDetails
                        ?.departmentDivision || "N/A"}
                    </span>
                  </div>
                )}

                {data?.professionalDetails?.designationIfOthers && (
                  <div className="personalInfoRow">
                    <p className="label200">
                      {t("professionalDetails.fields.designation")}:
                    </p>
                    <span>
                      {data?.professionalDetails
                        ?.designationIfOthers || "N/A"}
                    </span>
                  </div>
                )}

                {data?.professionalDetails?.branch && (
                  <div className="personalInfoRow">
                    <p className="label200">
                      {t("preview.labels.branch")}:
                    </p>
                    <span>
                      {data?.professionalDetails?.branch || "N/A"}
                    </span>
                  </div>
                )}

                {data?.professionalDetails?.rank && (
                  <div className="personalInfoRow">
                    <p className="label200">
                      {t("preview.labels.rank")}:
                    </p>
                    <span>
                      {data?.professionalDetails?.rank || "N/A"}
                    </span>
                  </div>
                )}

                {data?.professionalDetails?.annualIncome ? (
                  <div className="personalInfoRow">
                    <p className="label200">Annual Income:</p>
                    <span>
                      {data?.professionalDetails?.annualIncome || "N/A"}
                    </span>
                  </div>
                ) : null}
              </div>

              {data?.professionalDetails?.companyAddress && (
                <>
                  {data?.professionalDetails?.companyAddress && (
                    <div className="personalInfoRow">
                      <p className="label200">
                        {t(
                          "professionalDetails.fields.companyAddress"
                        )}
                        :
                      </p>
                      <span
                        style={{
                          whiteSpace: "pre-wrap",
                          wordBreak: "break-word",
                        }}
                      >
                        {data.professionalDetails.companyAddress.includes(
                          data?.professionalDetails?.companyPinCode ||
                          ""
                        )
                          ? data.professionalDetails.companyAddress
                          : `${data.professionalDetails.companyAddress
                          }${companyPincodeSuffix}`}
                      </span>
                    </div>
                  )}
                </>
              )}
              {data?.professionalDetails?.officeAddress && (
                <>
                  {" "}
                  <div className="personalInfoRow">
                    <p className="label200">
                      {t("professionalDetails.fields.officeAddress")}:
                    </p>
                    <span>
                      {formattedOfficeAddress}
                    </span>
                  </div>
                </>
              )}
            </div>
          );
        })}
    </>
  );
};



ApplicantDetails.propTypes = {
  applicantData: PropTypes.object,
  masterData: PropTypes.object,
};

export default ApplicantDetails;